"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const assert = require('assert').strict;
const { resolveExpression } = require('../evaluate');
module.exports = (oldOperatorId, newOperatorId) => {
    const accepts = ({ operator }) => operator === newOperatorId;
    const resolve = (expression, context) => __awaiter(void 0, void 0, void 0, function* () {
        assert(context);
        assert(expression);
        const newExpression = Object.assign(Object.assign({}, expression), { operator: oldOperatorId });
        const result = yield resolveExpression(newExpression, context);
        return !result;
    });
    return { accepts, resolve };
};
//# sourceMappingURL=negateExpression.js.map